import { createAction, props } from '@ngrx/store';

export interface SearchDocumentsRequest {
  // Not set for a search without category restriction, "category_id" is then omitted in the request body
  categoryId?: number;
  language: string;
  filterIds?: number[];
  searchTerm?: string;
  limit?: number;
  page?: number;
  searchType?: string;
  sort?: string;
  collectionId?: number;
  documentType?: string;
}

export const searchDocuments = createAction('[Search Documents] Get Documents', props<SearchDocumentsRequest>());

// Reloads the results with the parameters of the last search, e.g. after documents were removed
export const repeatLastSearch = createAction('[Search Documents] Repeat Last Search');

export const loadDocumentsSuccess = createAction('[Search Documents] Get Documents Success', props<{ data: any }>());

export const loadDocumentsFailure = createAction('[Search Documents] Get Documents Failure', props<{ error: any }>());

export const resetSearchDocuments = createAction('[Search Documents] Reset Search Documents');

export const updateSearchDocumentBookmark = createAction(
  '[Search Documents] Update Search Document Bookmark',
  props<{ documentId: number; isBookmarked: boolean }>(),
);

export const addCollectionToSearchDocuments = createAction(
  '[Search Documents] Add Collection To Search Documents',
  props<{ documentIds: number[]; collection: { id: number; name: string } }>(),
);

export const renameCollectionInSearchDocuments = createAction(
  '[Search Documents] Rename Collection In Search Documents',
  props<{ collectionId: number; name: string }>(),
);

export const removeCollectionFromSearchDocuments = createAction(
  '[Search Documents] Remove Collection From Search Documents',
  props<{ collectionId: number }>(),
);
